export class Notification {
  constructor(
    public id: string,
    public time: Date,
    public text: string,
    public icon: string,
    public iconColor: string,
    public soundAlert: boolean,
    public action: (action: string) => void
  ) {}
  public isNew = true;
  public isRead = false;
  public timeText: string | null = null;
}
